import { forwardRef, type Ref, type SVGProps } from "react";
const IconRestoreMailOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M30 26v-7.59a2 2 0 0 0-.16-.79L24.52 5.21A2 2 0 0 0 22.68 4H9.32a2 2 0 0 0-1.84 1.21l-.26.61L6 8.6A1 1 0 0 0 7 10a1 1 0 0 0 .86-.61l.32-.73.88-2.06.26-.6h13.36L28 18.41V26H4v-7.59l.09-.23.18-.42.18-.41A1 1 0 0 0 3.52 16a1 1 0 0 0-.92.6l-.36.83-.08.19a2.1 2.1 0 0 0-.16.79V26a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2" />
    <path d="M18.92 12.62a1.2 1.2 0 0 0-.21-.33l-4-4a1.004 1.004 0 0 0-1.42 1.42l2.3 2.29H3a1 1 0 1 0 0 2h12.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1.2 1.2 0 0 0 .21-.33c.051-.12.078-.25.08-.38a.9.9 0 0 0-.08-.38" />
    <path d="M25.11 18h-1.79a1.46 1.46 0 0 0-1.06.44L20.7 20h-9.17L10 18.44A1.47 1.47 0 0 0 8.91 18h-1.8a1 1 0 1 0 0 2H8.7l1.56 1.56a1.5 1.5 0 0 0 1.06.44h9.59c.408.005.8-.153 1.09-.44L23.53 20h1.58a1 1 0 1 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconRestoreMailOutlineSVG);
ForwardRef.displayName = "IconRestoreMailOutline";
export { ForwardRef as IconRestoreMailOutline };
